<template>
  <div class="common-container">
    <van-image width="100%" fit="contain" :src="insureImgUrl" />
    <div class="button-save" v-if="flag==1">
      <van-button @click="handleGoClick" type="primary" block color="#fe5958">《委托授权书》</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      insureImgUrl: require("@/assets/imgs/book/clause_letter101.png"),
      categoryId: "",
      flag:0
    };
  },
  created() {
    document.title = "《致学生家长的一封信》";
    this.categoryId = this.$route.query.categoryId;
    this.flag = this.$ComTools.isEmptyString(this.$route.query.flag)?0:this.$route.query.flag;
    if (!this.$ComTools.isEmptyString(this.categoryId)) {
      this.insureImgUrl = require("@/assets/imgs/book/clause_letter" +
        this.categoryId +
        ".png");
    }
  },
  methods: {
    handleGoClick() {
      this.$router.push({
        path: "/authorize_book",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-container {
  width: 100%;
  .button-save {
    /deep/ .van-button {
      background-color: transparent !important;
      border-color: transparent !important;
      color: #2440b3 !important;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/letter_book.vue